export default "<i class=\"object-icon {{icon}} {{iconClass}}\"></i>\n"